import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'auth-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class AuthInputComponent {
  @Input() hasError: boolean = false;
  @Input() label: string = '';
  @Input() twice: boolean = false;
  @Input() icon: string = '';
  @Input() forgotPassword: string = '';

  constructor (
      private router: Router
  ) {}

  showForgotPasswordForm(){
    this.router.navigate([{outlets: { popup: 'forgotPassword'}}]);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/popups/input/input.component.ts